
import { computed, defineComponent, onBeforeMount, onMounted, PropType, reactive, toRaw } from 'vue'

// components
import Modal from '@/common/components/UI/Modal/index.vue'
import TheInput from '@/common/components/UI/TheInput/index.vue'

// validation
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

// types
import { VariantT } from '@/core/types/survey.types'

export default defineComponent({
    components: {
        modal: Modal,
        'the-input': TheInput,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        isCreate: {
            type: Boolean,
            default: false,
        },
        isUpdate: {
            type: Boolean,
            default: false,
        },
        isDelete: {
            type: Boolean,
            default: false,
        },
        initialValue: {
            type: Object as PropType<VariantT>,
            default: null,
        },
    },
    emits: ['create', 'update', 'cancel'],
    setup(props, { emit }) {
        const state = reactive({
            title: null as string | null,
        })

        const state_form$ = useVuelidate({ title: { required } }, state)

        const modalTitle = computed(() => {
            if (props.isCreate) return 'Добавление варианта ответа'
            if (props.isUpdate) return 'Редактирование варианта ответа'
            if (props.isDelete) return 'Удаление варианта ответа'
            return 'modal title'
        })

        const modalConfirmButtonText = computed(() => {
            if (props.isCreate) return 'Добавить'
            if (props.isUpdate) return 'Редактировать'
            if (props.isDelete) return 'Удалить'
            return 'Подтвердить'
        })

        onMounted(() => {
            if (!props.isUpdate) return

            state.title = props.initialValue.title
            state_form$.value.$reset()
        })

        /** create emit */
        const emitCreate = () => {
            state_form$.value.$touch()
            if (state_form$.value.$invalid) return

            emit('create', toRaw(state))
        }

        const emitUpdate = () => {
            state_form$.value.$touch()
            if (state_form$.value.$invalid) return

            emit('update', toRaw(state))
        }

        const emitManager = () => {
            if (props.isCreate) emitCreate()
            if (props.isUpdate) emitUpdate()
        }

        const emitCancel = () => {
            emit('cancel')
        }

        return {
            state,
            state_form$,
            modalTitle,
            modalConfirmButtonText,
            emitManager,
            emitCancel,
        }
    },
})
